import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=7c048d76&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"
import style0 from "./Step3.vue?vue&type=style&index=0&id=7c048d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c048d76",
  null
  
)

export default component.exports